import type { StatusTone } from '@chatsdet/ui';
export type QaReportStatus = 'pending' | 'running' | 'issues_found' | 'no_issues' | 'failed';

type QaStatusMeta = {
  label: string;
  badgeVariant: 'outline' | 'success' | 'destructive' | 'secondary';
  tone: StatusTone;
};

const DEFAULT_META: QaStatusMeta = {
  label: 'Unavailable',
  badgeVariant: 'outline',
  tone: 'muted',
};

const QA_STATUS_META: Record<QaReportStatus, QaStatusMeta> = {
  issues_found: { label: 'Issues found', badgeVariant: 'destructive', tone: 'danger' },
  no_issues: { label: 'No issues', badgeVariant: 'success', tone: 'success' },
  failed: { label: 'Failed', badgeVariant: 'secondary', tone: 'danger' },
  running: { label: 'Running', badgeVariant: 'outline', tone: 'info' },
  pending: { label: 'Pending', badgeVariant: 'outline', tone: 'muted' },
};

export function getQaStatusMeta(status?: QaReportStatus | null): QaStatusMeta {
  if (!status) {
    return DEFAULT_META;
  }
  return QA_STATUS_META[status] ?? DEFAULT_META;
}
